/*
  What checkout (step four) should do with the currently selected activity.

  Returns:
  - 'add'                - not in the cart yet: add it and create/attach the SF line
  - 'create-opportunity' - already in the cart but the SF opportunity was never
                           created (earlier failure): retry creation, no re-add
  - 'none'               - already in the cart with a live opportunity (e.g.
                           back-navigation into checkout): nothing to do

  Replaces the inverted guard that re-added the activity (and created a
  duplicate OpportunityLineItem in Salesforce) on every checkout re-entry
  once an opportunity existed.
*/
export const cartActionForActivity = (selectedActivity, selectedActivities, opportunityId) => {
    if (!selectedActivity) return 'none';
    /*
      Cart identity = campaign + visitor mix, matching removeActivity and the
      SF line-item lookups. The same campaign re-selected with a DIFFERENT
      party size is a legitimate new cart line (e.g. רכישה נוספת of the same
      show for 5 after buying it for 4); only an identical campaign+visitors
      pair is the checkout re-entry bounce that must not re-add.
    */
    const sameVisitors = (a, b) =>
        (a?.adults || 0) === (b?.adults || 0) && (a?.underAge || 0) === (b?.underAge || 0);
    const inCart = (selectedActivities || []).some((item) =>
        item.campaignId === selectedActivity.campaignId && sameVisitors(item.visitors, selectedActivity.visitors));
    if (!inCart) return 'add';
    if (!opportunityId) return 'create-opportunity';
    return 'none';
};
